import {  privacy_policy_ERROR, privacy_policy_INFO } from "../types";


const initialState = {
  privacy_policy: {},
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case privacy_policy_INFO:
      return {
        ...state,
        privacy_policy: action.payload,
        loading: false,
      };
    case privacy_policy_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
